<script>
import { sumBy } from 'lodash'
import { debounce } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'quotationControl',
  props: ['value'],
  data() {
    return {
      model: {}
    }
  },
  computed: {
    ...mapState('saleInvoiceStore', ['quotations', 'currencies'])
  },
  methods: {
    ...mapActions('saleInvoiceStore', [
      'onGetQuotation',
      'onGetDetailById',
      'onGetProduct',
      'onGetCustomer'
    ]),
    handleCustomerSearch: debounce(async function(searchString) {
      this.onGetQuotation({ params: { search: searchString } })
    }, 800),
    async onChangeQuotation(value) {
      this.value.product_detail = []
      this.value.contract_id = undefined

      if (value === undefined) {
        this.value.customer_id = undefined
        this.value.seller_id = undefined
        this.updateMainAmount()
        return
      }

      this.$store.commit('saleInvoiceStore/SET_LOADING', true)
      const quotationDetail = await this.onGetDetailById(value)
      const productId = quotationDetail.map(el => el.product_id)
      const products = await this.onGetProduct({
        params: {
          product_id: productId
        }
      })

      this.$store.commit('saleInvoiceStore/SET_LOADING', false)
      this.$emit('product', products.data)

      if (quotationDetail.length) {
        this.value.customer_id = quotationDetail[0].customer_id

        const customer = await this.onGetCustomer({
          params: {
            search_customer_id: this.value.customer_id
          }
        })

        if (customer.length) {
          this.model.credit_day = customer[0].credit_day
          this.creditDayChange()
          if (customer[0].employee_id) {
            this.model.seller_id = customer[0].employee_id
            this.onGetSale(customer[0].employee_id)
          }
        }
      }

      quotationDetail.forEach(el => {
        const product = products.data.find(p => p.product_id === el.product_id)
        if (product !== undefined) {
          const subtotal = (el.quantity ? el.quantity : 1) * el.unit_price
          const row = this.setValueCurrency({
            product_id: el.product_id,
            product_name_en: product.product_name_en,
            product_name_kh: product.product_name_kh,
            barcode: product.barcode,
            uom_id: el.uom_id,
            quantity: el.quantity ? el.quantity : 1,

            unit_price: el.unit_price,
            input_unit_price: el.unit_price, // add new

            discount_type: el.discount_type ? el.discount_type : '%',
            discount_rate: el.discount_rate ? el.discount_rate : 0,

            input_discount_amount: 0, // add new
            discount_amount: 0,

            total_after_discount: 0,
            vat_rate: 0,
            vat_amount: 0,

            grand_total: subtotal,

            promo_ref_promo_product_id: null,
            promo_type_id: '',
            vat_eligible: product.vat_eligible,
            serial_list: [],
            is_custom: false,
            is_calculate_stock: product.is_calculate_stock,
            has_serial: product.is_generate_unique_serial,
            ending_balance: product.ending_balance,
            cost: parseFloat(this.getCost(product, el.uom_id)),

            fx_rate: undefined,
            fx_rate_ratio: undefined,
            input_currency_id: undefined,
            currency_id: undefined
          })
          this.onCalculateWhenChange(row)
          this.value.product_detail.push(row)
        }
      })
      this.updateMainAmount()
    },
    setValueCurrency(data) {
      const findDefaultCurrency = this.currencies.find(c => c.is_default)
      if (findDefaultCurrency) {
        data.currency_id = findDefaultCurrency.currency_id
        data.input_currency_id = findDefaultCurrency.currency_id
        data.fx_rate = 1
        data.fx_rate_ratio = 1
      }

      return data
    },
    creditDayChange() {
      if (this.value.amount_due > 0) {
        this.updateNextPaymentDate()
      }
    },
    updateNextPaymentDate() {
      if (this.value.stock_out_date && this.value.amount_due > 0) {
        this.value.next_payment_date = moment(
          this.value.stock_out_date,
          'DD-MM-YYYY'
        )
          .add(this.value.credit_day, 'days')
          .format('DD-MM-YYYY')
      }
    },
    getCost(product, uomId) {
      if (product.sale_code) {
        const saleCode = product.sale_code.find(s => s.uom_id === uomId)
        if (saleCode.product_price) {
          return saleCode.product_price.cost
        }
      }
      return 0
    },
    onCalculateWhenChange(row) {
      // Calculate subtotal before discount
      const subtotal = row.quantity * row.input_unit_price

      // convert from input_unit_price to default currency value
      this.calculateAmountToDefaultCurrency(row, 'unit_price')

      // Calculate discount amount
      if (row.discount_type === '%') {
        row.input_discount_amount = (subtotal * row.discount_rate) / 100
        this.calculateAmountToDefaultCurrency(row, 'discount_amount')
      } else {
        row.input_discount_amount = row.discount_rate
        // calcualte discount amount from input_discount_amount to default currency
        this.calculateAmountToDefaultCurrency(row, 'discount_amount')
      }

      row.total_after_discount =
        row.quantity * row.unit_price - row.discount_amount

      // Calculate VAT amount if product is VAT eligible
      if (row.vat_eligible) {
        row.vat_amount = (row.total_after_discount * row.vat_rate) / 100
      } else {
        row.vat_amount = 0
      }
      row.grand_total = row.total_after_discount + row.vat_amount
    },
    calculateAmountToDefaultCurrency(row, keyColunm) {
      if (row.input_currency_id == this.defaultCurrencyId)
        return (row[keyColunm] = row[`input_${keyColunm}`])

      row[keyColunm] = row[`input_${keyColunm}`] * row.fx_rate_ratio
    },
    updateMainAmount() {
      // update sub total amount to main
      this.value.sub_total = sumBy(this.value.product_detail, 'grand_total')
      this.value.total_after_discount =
        this.value.sub_total -
        this.value.input_discount * this.value.fx_rate_ratio

      if (this.value.vat_rate > 0) {
        this.vat_amount =
          (this.value.total_after_discount * this.value.vat_rate) / 100
      }

      this.value.grand_total =
        this.value.total_after_discount + this.value.vat_amount

      this.value.amount_due = this.value.grand_total - this.value.amount_paid

      // next payment date if amount due is 0
      if (this.value.amount_due === 0) {
        this.value.next_payment_date = null
      }
      if (this.value.amount_due > 0) {
        this.value.next_payment_date = moment(
          this.value.stock_out_date,
          'DD-MM-YYYY'
        )
          .add(this.value.credit_day, 'days')
          .format('DD-MM-YYYY')
      }
    }
  }
}
</script>

<template>
  <div>
    <a-select
      v-model="value.quotation_id"
      show-search
      :allowClear="true"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="null"
      :options="quotations"
      filterable
      remote
      @search="handleCustomerSearch"
      @change="onChangeQuotation"
      class="ts-w-48"
      placeholder="Search quotation"
    ></a-select>
  </div>
</template>
